/**
 * Indicates if we are running a development build or a production build
 */
export const isDev = process.env.NODE_ENV === 'development';
